import Axios from 'axios';
import Cookies from 'js-cookie';
import {oktaAuth} from 'services/auth.service';
import {timeOut} from 'lib/utils';
import {AUDIT_SESSION_HEADER, getAuditSessionId} from 'lib/audit-session';

export const axios = Axios.create({
    baseURL: window.env.REACT_APP_API_HOST,
    headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
    },
});

const getOktaAuthState = async () => {
    let authState = await oktaAuth.authStateManager?.getAuthState();

    if (authState?.isPending) {
        await timeOut(100);

        return getOktaAuthState();
    }

    return authState || {};
};

let lastAccessToken = '';

/**
 * The most recent access token the interceptor used; readable synchronously, e.g. while the page unloads.
 */
export const getLastAccessToken = () => lastAccessToken;

axios.interceptors.request.use(async ({signal, ...config}) => {
    let authState = await getOktaAuthState();

    let accessToken = '';

    if (authState.isAuthenticated) {
        accessToken = authState.accessToken?.accessToken;
    }

    if (!accessToken) {
        accessToken = Cookies.get('token');
    }

    if (accessToken) {
        lastAccessToken = accessToken;
        config.headers.Authorization = `Bearer ${accessToken}`;
    }

    const auditSessionId = getAuditSessionId();

    if (auditSessionId) {
        config.headers[AUDIT_SESSION_HEADER] = auditSessionId;
    }

    if (!config.cancelToken) {
        const source = Axios.CancelToken.source();

        if (signal) {
            if (signal.aborted) {
                throw new Error('aborted');
            }

            signal.addEventListener('abort', () => source.cancel());
        }

        config.cancelToken = source.token;
    }

    return config;
});

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (Axios.isCancel(error)) {
            return Promise.resolve({data: undefined});
        }

        return Promise.reject(error);
    },
);
